import React, { useState, useEffect } from "react";
import {
  CardBody,
  CardHeader,
  Container,
  Row,
  Col,
  Card,
  CardTitle,
  Form,
  Label,
  Input,
  Button,
  Table,
  Modal,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { ToastContainer, toast } from "react-toastify";
import ReactPaginate from "react-paginate";
import axios from "axios";
import { URLS } from "../../Url";

const Community = () => {
  const [modal_small, setmodal_small] = useState(false);
  const [banner, setbanner] = useState([]);
  const [form, setform] = useState({ community: "" });
  const [form1, setform1] = useState({ community: "" });

  const tog_small = () => setmodal_small(!modal_small);

  const handleChange = e => {
    setform({ ...form, [e.target.name]: e.target.value });
  };

  const handleChange1 = e => {
    setform1({ ...form1, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    GetAllCategorys();
  }, []);

  const token = JSON.parse(localStorage.getItem("authUser"))?.token;

  const [listPerPage] = useState(5);
  const [pageNumber, setPageNumber] = useState(0);

  const pagesVisited = pageNumber * listPerPage;
  const lists = banner.slice(pagesVisited, pagesVisited + listPerPage);
  const pageCount = Math.ceil(banner.length / listPerPage);
  const changePage = ({ selected }) => setPageNumber(selected);

  const AddCategory = () => {
    axios
      .post(
        "https://api.jaininternationalnetwork.com/v1/a2zsolutionsapi/admin/community/addcommunity",
        new URLSearchParams({ community: form.community }),
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(res => {
        if (res.status === 200) {
          toast(res.data.message);
          GetAllCategorys();
          clearForm();
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 400) {
          toast(error.response.data.message);
        }
      });
  };

  const EditCategory = () => {
    axios
      .put(
        `https://api.jaininternationalnetwork.com/v1/a2zsolutionsapi/admin/community/editcommunity/${form1._id}`,
        new URLSearchParams({ community: form1.community }),
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(res => {
        if (res.status === 200) {
          toast(res.data.message);
          GetAllCategorys();
          setmodal_small(false);
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 400) {
          toast(error.response.data.message);
        }
      });
  };

  const DeleteCategory = data => {
    axios
      .delete(
        `https://api.jaininternationalnetwork.com/v1/a2zsolutionsapi/admin/community/deletecommunity/${data._id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(res => {
        if (res.status === 200) {
          toast(res.data.message);
          GetAllCategorys();
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 400) {
          toast(error.response.data.message);
        }
      });
  };

  const manageDelete = data => {
    if (window.confirm("Do you really want to Delete?")) {
      DeleteCategory(data);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    AddCategory();
  };

  const handleSubmit1 = e => {
    e.preventDefault();
    EditCategory();
  };

  const GetAllCategorys = () => {
    axios
      .post(
        "https://api.jaininternationalnetwork.com/v1/a2zsolutionsapi/admin/community/getall",
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(res => {
        if (res.data.success) {
          const userCommunityObjects = res.data.usercommunities.map((community, index) => ({
            _id: `user_${index}`,
            community: community
          }));
  
          // comibing the communities and usercommunities
          const allCommunities = [
            ...(res.data.communities || []),
            ...userCommunityObjects
          ];
          
          setbanner(allCommunities);
        } else {
          toast(res.data.message); 
        }
      })
  };

  const clearForm = () => setform({ community: "" });

  const getpopup = data => {
    setform1(data);
    tog_small();
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Home" breadcrumbItem="Community List" />
          <Row>
            <Col md={4}>
              <Card>
                <CardHeader className="bg-white">
                  <CardTitle>Add Community</CardTitle>
                </CardHeader>
                <CardBody>
                  <Form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Community
                        <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        id="basicpill-firstname-input1"
                        placeholder="Enter community"
                        required
                        name="community"
                        value={form.community}
                        onChange={handleChange}
                      />
                    </div>
                    <div style={{ float: "right" }}>
                      <Button color="primary" type="submit">
                        Submit <i className="fas fa-check-circle"></i>
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
            <Col>
              <Card>
                <CardHeader className="bg-white">
                  <CardTitle>Community List</CardTitle>
                </CardHeader>
                <CardBody>
                  <div>
                    <div className="table-responsive">
                      <Table className="table table-bordered mb-4 mt-2">
                        <thead>
                          <tr className="text-center">
                            <th>S.No</th>
                            <th>Community</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lists.map((data, key) => (
                            <tr key={key} className="text-center">
                              <th>{(pageNumber - 1) * 5 + key + 6}</th>
                              <td>{data.community}</td>
                              <td>
                                <Button
                                  onClick={() => getpopup(data)}
                                  className="m-1 btn-sm"
                                  color="success"
                                >
                                  <div className="d-flex">
                                    <small>
                                      <i className="bx bx-edit m-1"></i>
                                      Edit
                                    </small>
                                  </div>
                                </Button>
                                <Button
                                  onClick={() => manageDelete(data)}
                                  className="m-1 btn-sm"
                                  color="danger"
                                >
                                  <div className="d-flex">
                                    <small>
                                      <i className="bx bx-trash m-1"></i>
                                      Delete
                                    </small>
                                  </div>
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                      <div className="mt-3" style={{ float: "right" }}>
                        <ReactPaginate
                          previousLabel={"Previous"}
                          nextLabel={"Next"}
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={"pagination"}
                          previousLinkClassName={"previousBttn"}
                          nextLinkClassName={"nextBttn"}
                          disabledClassName={"disabled"}
                          activeClassName={"active"}
                          total={lists.length}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <Modal
          size="md"
          isOpen={modal_small}
          toggle={tog_small}
          centered
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="mySmallModalLabel">
              Edit Community
            </h5>
            <button
              onClick={() => setmodal_small(false)}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Form onSubmit={handleSubmit1}>
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">
                  Community <span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  className="form-control"
                  id="basicpill-firstname-input1"
                  placeholder="Enter Community"
                  required
                  name="community"
                  value={form1.community}
                  onChange={handleChange1}
                />
              </div>
              <div style={{ float: "right" }}>
                <Button
                  onClick={() => setmodal_small(false)}
                  color="danger"
                  type="button"
                >
                  Cancel <i className="fas fa-times-circle"></i>
                </Button>
                <Button className="m-1" color="primary" type="submit">
                  Submit <i className="fas fa-check-circle"></i>
                </Button>
              </div>
            </Form>
          </div>
        </Modal>
        <ToastContainer />
      </div>
    </React.Fragment>
  );
};

export default Community;